import { alpha, Box, LinearProgress, Paper, Stack, Typography, useTheme } from '@pulse/ui';

import { formatTotalHours } from '../utils/timesheetGrid';

// Same percent + LinearProgress visual convention already used by HoursLoggedCard.tsx (Home)
// and ProjectCompletionCard.tsx (Delivery) — built locally rather than reused since all three
// are typed to a different response shape.
export function WeeklyTotalCard({ totalHours, targetHours }: { totalHours: number; targetHours: number }) {
  const theme = useTheme();
  const percent = targetHours > 0 ? Math.round((totalHours / targetHours) * 100) : 0;
  const progressValue = Math.min(100, percent);

  return (
    <Paper sx={{ p: 2, borderRadius: 3 }}>
      <Stack spacing={1}>
        <Box>
          <Typography variant="h5" fontWeight={800} color="primary.main" lineHeight={1}>
            {formatTotalHours(totalHours)}
            <Typography component="span" variant="body2" color="text.secondary"> hrs logged this week </Typography>
          </Typography>
        </Box>
        <LinearProgress
          variant="determinate"
          value={progressValue}
          sx={{ height: 6, borderRadius: 3, bgcolor: alpha(theme.palette.secondary.main, 0.15) }}
          color={percent >= 100 ? 'success' : 'secondary'}
        />
      </Stack>
    </Paper>
  );
}
